import React from 'react';

const TestTest = () => {
    return (
        <div>

        </div>
    );
};

export default TestTest;


//
// import React, { useRef, useEffect } from 'react';
// import axios from "axios";
// import {API_PATH} from "../../components/const";
//
// const TestTest2 = () => {
//     const canvasRef = useRef(null);
//     const videoRef = useRef(null);
//     var color_choices = [
//         "#00FF47",
//     ];
//
//
//     var rgb_color = color_choices[Math.floor(Math.random() * color_choices.length)]
//     var opaque_color = 'rgba(0, 255, 71, 0.22)';
//     // var scaleFactor = 1;
//     var canvas = document.getElementById('canvas');
//     var ctx = canvas?.getContext('2d');
//     function drawPolygon(vertices) {
//         var canvas = document.getElementById('canvas');
//         var ctx = canvas?.getContext('2d');
//
//         console.log(vertices)
//         ctx?.beginPath();
//         ctx.strokeStyle = rgb_color;
//         ctx.lineWidth = "10";
//         ctx?.moveTo(vertices[0].x, vertices[0].y);
//
//         for (var i = 1; i < vertices.length; i++) {
//             ctx?.lineTo(vertices[i].x, vertices[i].y);
//         }
//
//         ctx?.closePath();
//         ctx?.stroke();
//         // ctx.fillStyle = opaque_color; // Set the fill color
//         ctx.fill();
//
//     }
//     const fc = (roiId) => {
//         // https://api.cradle-vision.com/company/5/camera/smartcamera/detail/4
//         axios.get("https://api.cradle-vision.com/company/5/roi_analytics/1/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
//             .then(res2 => {
//                 for (let i= 0; i < res2.data?.length; i++){
//                     drawPolygon( res2?.data[i]?.points?.sort((a, b) => a.order_number - b.order_number))
//                 }
//             })
//     }
//     useEffect(() => {
//         const canvas = canvasRef.current;
//         const video = videoRef.current;
//
//         // Set canvas dimensions
//         canvas.width = window.innerWidth;
//         canvas.height = window.innerHeight;
//         const draw = () => {
//             const ctx = canvas.getContext('2d');
//             ctx.clearRect(0, 0, canvas.width, canvas.height);
//             // Your canvas drawing code here
//             // ...
//
//             // Draw the video frame on the canvas
//             ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
//
//             // Repeat the draw function on the next animation frame
//             requestAnimationFrame(draw);
//         };
//
//         const startDrawing = () => {
//             // Start drawing loop
//             draw();
//         };
//
//         // Event listener to start drawing when the video is loaded
//         video.addEventListener('loadeddata', startDrawing);
//
//         return () => {
//             // Remove event listener when the component is unmounted
//             video.removeEventListener('loadeddata', startDrawing);
//         };
//
//
//
//         const drawPolygon = () => {
//             ctx.beginPath();
//             ctx.moveTo(50, 50);
//             ctx.lineTo(150, 50);
//             ctx.lineTo(150, 150);
//             ctx.lineTo(50, 150);
//             ctx.strokeStyle = rgb_color;
//
//             ctx.closePath();
//             ctx.stroke();
//         };
//
//         drawPolygon();
//     }, []);
//
//     return (
//         <div>
//             <button onClick={fc}>sadasdsad</button>
//             <canvas ref={canvasRef} id="canvas"></canvas>
//             <video ref={videoRef} muted  autoPlay={true} className="w-100  "  controls>
//                 <source src="/video/vd1.mp4" type="video/mp4" />
//                 Your browser does not support the video tag.
//             </video>
//
//         </div>
//     );
// };
//
// export default TestTest2;
